<template>
  <div
    class="product-card"
    :class="{ intersected: isIntersecting, thumb }"
    ref="el"
    v-if="media.length"
  >
    <a class="product-card__link" :aria-label="product.title" :href="`/products/${product.handle}`">
      <!-- ✨ Hallmark -->
      <ProductCardHallmark :value="hallmarkValue" />

      <ProductCardMedia :media="media" />

      <div class="product-card__caption">
        <h2 class="product-card__title">
          <ProductCaptionTitle :title="product.title" />
        </h2>
        <ProductCardPrices class="prices" />
      </div>
    </a>
  </div>
</template>

<script lang="ts" setup>
import ProductCaptionTitle from './ProductCardTitle.vue'
import ProductCardMedia from './ProductCardMedia.vue'
import { ref, withDefaults, computed } from 'vue'
import useIntersection from '../../../composables/useIntersection'
import ProductCardPrices from './ProductCardPrices.vue'
import { ProductFieldsFragment } from '_library/src/storefront/generated'
import { useProductContext } from '../../../context/useProductContext'
import ProductCardHallmark from './ProductCardHallmark.vue'

const el = ref(null)
const { isIntersecting } = useIntersection(el)

const props = withDefaults(
  defineProps<{
    product: ProductFieldsFragment
    thumb?: boolean
  }>(),
  {
    thumb: false,
  }
)

const productContext = useProductContext({ product: props.product })

const { media } = productContext

const hallmarkValue = computed(() => (props.product as any)?.hallmark?.value || null)
</script>

<style lang="scss" scoped>
@import '~styles/base';

.product-card {
  --caption-height: #{lineHeights(2)};

  transition: var(--transition-intersection);
  position: relative;
  display: flex;

  @include breakpoint('m+') {
    aspect-ratio: 500 / 700;
  }

  &:not(.intersected) {
    opacity: 0;
  }

  &__link {
    width: 100%;
    display: flex;
    flex-direction: column;
    cursor: pointer;
    margin: 0;
  }

  &__title {
    flex: 1;
    text-decoration: none;

    @include breakpoint('xl') {
    }
  }

  &__caption {
    display: flex;
    width: 100%;
    margin-top: 8px;

    @include breakpoint('xl') {
      display: block;
    }

    @media (min-width: 900px) {
      position: absolute;
      top: 100%;
      left: 0;
    }
  }

  @media (hover: hover) {
    &.thumb {
      .product-card__caption {
        opacity: 0;
      }

      &:focus,
      &:hover {
        .product-card__caption {
          opacity: 1;
        }
      }
    }
  }
}
</style>
